import { Building2 } from 'lucide-react';
import { useTenantContext } from '@/contexts/TenantContext';
import { useUserRole } from '@/hooks/useUserRole';
import { Badge } from '@/components/ui/badge';
import { Skeleton } from '@/components/ui/skeleton';

export function TenantDisplay() {
  const { activeTenantName, isSwitched, isLoading } = useTenantContext();
  const { isSuperAdmin } = useUserRole();

  if (isLoading) {
    return <Skeleton className="h-6 w-32" />;
  }

  if (!activeTenantName) {
    return null;
  }

  return (
    <div className="flex items-center gap-2">
      <div className="flex items-center gap-2 text-sm font-medium text-foreground">
        <Building2 className="h-4 w-4 text-muted-foreground" />
        <span className="inline truncate max-w-[120px] sm:max-w-[200px] lg:max-w-[300px]">
          {activeTenantName}
        </span>
      </div>
      {isSuperAdmin && isSwitched && (
        <Badge variant="outline" className="text-xs">
          Switched
        </Badge>
      )}
    </div>
  );
}
